import dayjs from "dayjs";

// L'option "Obstétrique" ou "Orthodontie" est disponible si :
// - L'activité est 'Retraité'
// - La personne a entre 55 et 80 ans
const obstetriqueOuOrthodontieAvailable = (activite, dateDeNaissance) => {
    const date = dayjs(dateDeNaissance, 'DD/MM/YYYY', true)
    const age = dayjs().diff(date, 'year')

    console.debug("[obstetriqueOuOrthodontieAvailable]", "age", age)

    const RG1 = activite === "Retraité"
    const RG2 = (age >= 55 && age < 80)

    return RG1 && RG2 ? '1' : '0'
}

export {obstetriqueOuOrthodontieAvailable}
